import { useSelector } from "react-redux";
import AddressDropdown from "../../components/AddressDropdown/AddressDropdown";
import "./ClientPurchaseOrderStatus.scss";
import React, { useEffect, useState } from "react";
import {
  getUserAddresses,
  getWarehouseUserAddresses,
} from "../../redux/user/userSelector";
import { useNavigate, useParams } from "react-router-dom";
import { UserAddress } from "../../redux/user/userTypes";
import { ClientPurchaseOrder } from "../../models/PurchaseOrder";
import { formatDateWithYear } from "../../utils/date-util";
import ApiService from "../../services/apiService";
import URLS from "../../urls/Urls";
import { CLIENT_PO_PROPERTY_MAP } from "../../constants/PurchaseData";
import Filter from "../../components/Filter/Filter";
import { FilterOptionSchema } from "../../components/Filter/filter.data";
import { commaFormat, formatDate, round } from "../../utils/Helper";
import OutsideAlerter from "../../utils/OutsideClickDetector";
import CommentSection from "../../components/CommentSection/CommentSection";
import { PO_TYPE } from "./ClientPurchaseOrder.data";
import XetModal from "../../components/shared/xet-modal/XetModal";
import PurchaseOrderDeliveryDetailPopup from "../../components/PurchaseOrderDeliveryDetailPopup/PurchaseOrderDeliveryDetailPopup";
import { Tooltip } from "@mui/material";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  breakPointObserver,
  ScreenSizes,
} from "../../utils/BreakpointObserver";
import PurchaseOrderDeliveryDetailPopupTab from "../../components/PurchaseOrderDeliveryDetailPopupTab/PurchaseOrderDeliveryDetailPopupTab";

const ClientPurchaseOrderStatus: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const addresses = useSelector(getWarehouseUserAddresses);
  const currentAddress = useSelector(getUserAddresses).find(
    (address) => address.id == Number(id)
  );
  const [breakpoint, setBreakpoint] = useState("");

  const [selectedAddress, setSelectedAddress] = useState<UserAddress | null>(
    null
  );

  const [openCommentSectionId, setOpenCommentSectionId] = useState(-1);
  const [deliveryShowInfoId, setDeliveryShowInfoId] = useState(-1);
  const [hiddenPos, setHiddenPos] = useState<number[]>([]);
  const [poType, setPoType] = useState(PO_TYPE.PO_RECEIVED);
  const [totalVendors, setTotalVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState<FilterOptionSchema>();
  const [clientPos, setClientPos] = useState<ClientPurchaseOrder[]>([]);
  const [filteredClientPos, setFilteredClientPos] = useState<
    ClientPurchaseOrder[]
  >([]);

  useEffect(() => {
    fetchVendors().then((r) => {
      return r;
    });
  }, []);

  useEffect(() => {
    // if (selectedAddress) {
    getClientPurchaseOrderList().then((r) => {
      return r;
    });
    // }
  }, [selectedAddress, selectedVendor, poType]);

  useEffect(() => {
    breakPointObserver(setBreakpoint);
  }, [breakpoint]);

  const fetchVendors = async () => {
    try {
      const { data } = await ApiService().client.get(
        URLS.VENDORS.FETCH_VENDOR_LIST
      );
      setTotalVendors(data.vendors);
    } catch (e) {
      console.error(e);
    }
  };

  const getClientPurchaseOrderList = async () => {
    let url = `${URLS.PURCHASE_ORDER.GET_CLIENT_PO_LIST}`;
    const queryParams = [];

    if (selectedVendor?.id) {
      queryParams.push(`vendor_id=${selectedVendor.id}`);
    }

    if (selectedAddress?.id) {
      queryParams.push(`address_id=${selectedAddress.id}`);
    }

    if (poType === PO_TYPE.PO_RECEIVED) {
      queryParams.push(`po_type=${PO_TYPE.PO_RECEIVED}`);
    }
    if (poType === PO_TYPE.DELIVERED) {
      queryParams.push(`po_type=${PO_TYPE.DELIVERED}`);
    }

    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }
    try {
      const { data } = await ApiService().client.get(url);
      setClientPos(data.data);
      setFilteredClientPos(data.data);
    } catch (error) {
      console.error("Error fetching quotes:", error);
      return [];
    }
  };

  const handleSearchFile = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const searchText = event.target.value;
    const filteredClientPos = clientPos.filter((po) =>
      po.po_number.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredClientPos(filteredClientPos);
  };

  const handleAddressSelection = (val: UserAddress) => {
    if (val.id === selectedAddress?.id) {
      setSelectedAddress(null);
    } else {
      setSelectedAddress(val);
      navigate(`/purchase-orders`);
    }
  };

  const handleDetailPageNavigation = (val: number) => {
    navigate(`/purchase-orders/${val}`);
  };

  const closeComment = () => {
    navigate(`/purchase-orders`);
    setOpenCommentSectionId(-1);
  };

  const openComment = (po_id: number) => {
    navigate(`/purchase-orders?comment=true`);
  };

  const handleCollapse = (po_id: number) => {
    setHiddenPos((prevHiddenPos) => {
      if (prevHiddenPos.includes(po_id)) {
        // Remove it
        return prevHiddenPos.filter((id) => id !== po_id);
      } else {
        // Add it
        return [...prevHiddenPos, po_id];
      }
    });
  };

  return (
    <div className="purchase-order-list-page-content flex-column ">
      <div className="purchase-order-list-breadcrumbs-container flex-row gap-4 px-32 py-16">
        <p
          className="xetgo-font-tag bold cursor-pointer"
          style={{ color: "#AA5200" }}
        >
          Purchase Order
        </p>
      </div>
      <div className="purchase-order-list-upper-container px-16 py-12 flex-row justify-content-space-between align-items-center gap-24">
        <div className="search-filter-main-container flex-row align-items-center gap-12 full-width border-box">
          <div className="search-bar-container">
            <input
              className="py-8 px-34 search-input border-box xetgo-font-tag"
              onChange={handleSearchFile}
              placeholder="Search by PO Number"
            />
            <img
              height={16}
              width={16}
              className="search-icon"
              src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240821094925-search.svg"
              alt="search-icon"
            />
          </div>

          <div className="header-right-section flex-row align-items-center gap-8">
            <img
              src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240227122733-list-filter.svg"
              alt="filter"
            />
            <Filter
              option={{
                key: "vendors",
                name: "Vendor",
              }}
              optionList={totalVendors}
              multipleSelection={false}
              onSelection={(val, _option) => {
                setSelectedVendor(val[0]);
              }}
              mode="showNames"
              showPlaceholder={true}
              direction="right"
              addNew={false}
              classname="category-filter-input"
              preSelected={selectedVendor ? [selectedVendor] : []}
            />
            <AddressDropdown
              showId={false}
              selected={selectedAddress}
              onSelection={handleAddressSelection}
              addresses={addresses}
              classname="category-filter-input"
            />
          </div>
        </div>
        <div className="po-type-container flex-row xetgo-font-tag">
          <p
            onClick={() => setPoType(PO_TYPE.PO_RECEIVED)}
            className={`po-type px-12 py-8 cursor-pointer ${
              poType == PO_TYPE.PO_RECEIVED && "active-po-type"
            }`}
          >
            Ongoing
          </p>
          <p
            onClick={() => setPoType(PO_TYPE.DELIVERED)}
            className={`po-type px-12 py-8 cursor-pointer ${
              poType == PO_TYPE.DELIVERED && "active-po-type"
            }`}
          >
            Delivered
          </p>
        </div>
      </div>

      <div className="purchase-order-list-lower-container p-16 full-height">
        {filteredClientPos.length > 0 ? (
          <div className="po-status-list-container ">
            <div className="all-client-po-wrapper overflow-scroll p-12 flex-column gap-24">
              {filteredClientPos.length > 0 &&
                filteredClientPos.map(
                  (purchaseOrder: ClientPurchaseOrder, poIndex: number) => {
                    return (
                      <div
                        key={poIndex}
                        className="po-main-container flex-column gap-12 p-12"
                      >
                        <div className="flex-row gap-12">
                          {ScreenSizes.MOBILE == breakpoint ||
                          ScreenSizes.MINI_TABLET == breakpoint ? (
                            <div className="po-multi-boxes gap-12 flex-1 xetgo-font-tag">
                              <div className="flex-row gap-12 hh">
                                <div className="flex-row gap-12 flex-1 po-mob-container ">
                                  <div
                                    className="po-enquiry-id-box upper-big-boxes justify-content-center flex-column gap-12 px-12 py-14 border-box xetgo-font-tag justify-content-space-between cursor-pointer"
                                    onClick={() =>
                                      window.open(
                                        purchaseOrder.po_file,
                                        "_blank"
                                      )
                                    }
                                  >
                                    <div className="inner-text-box flex-column gap-8">
                                      <p className="bold">Purchase Order</p>
                                      <div
                                        className="flex-row justify-content-space-between"
                                        style={{ alignItems: "flex-end" }}
                                      >
                                        <p className="xetgo-font-tag box-title">
                                          {purchaseOrder.po_number}
                                        </p>
                                        <p className="xetgo-font-tag box-title">
                                          {formatDate(purchaseOrder.po_date)}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex-row gap-12 flex-1">
                                    <div className=" upper-big-boxes justify-content-center flex-1 flex-column gap-12 px-12 py-14 xetgo-font-tag justify-content-space-between">
                                      <div className="inner-text-box flex-column gap-8">
                                        <p className="bold sub-title">
                                          PO Value
                                        </p>
                                        <p className="xetgo-font-tag box-title">
                                          ₹{" "}
                                          {commaFormat(
                                            purchaseOrder.po_value.toString()
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="upper-big-boxes justify-content-center flex-1 flex-column gap-12 px-12 py-14 xetgo-font-tag justify-content-space-between">
                                      <div className="inner-text-box flex-column gap-8">
                                        <p className="bold sub-title">Vendor</p>
                                        <p className="xetgo-font-tag box-title">
                                          {purchaseOrder?.vendor_name}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {hiddenPos.includes(purchaseOrder.id) ? (
                                  <img
                                    onClick={() =>
                                      handleCollapse(purchaseOrder.id)
                                    }
                                    style={{ rotate: "180deg" }}
                                    className="cursor-pointer"
                                    height={28}
                                    width={28}
                                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250618103555-download.svg"
                                    alt="minimise-icon"
                                  />
                                ) : (
                                  <img
                                    onClick={() =>
                                      handleCollapse(purchaseOrder.id)
                                    }
                                    className="cursor-pointer"
                                    height={28}
                                    width={28}
                                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250618103555-download.svg"
                                    alt="minimise-icon"
                                  />
                                )}
                              </div>
                              <div className="flex-row gap-12 flex-1">
                                <div className=" upper-big-boxes justify-content-center flex-column gap-12 px-12 py-14 xetgo-font-tag flex-1">
                                  <div className="inner-text-box flex-row gap-8 justify-content-space-between">
                                    <div className="address-title flex-column gap-4">
                                      {" "}
                                      {ScreenSizes.MINI_TABLET ===
                                        breakpoint && (
                                        <p className="bold sub-title">
                                          Address
                                        </p>
                                      )}
                                      <div className="flex-row gap-2">
                                        <p className="xetgo-font-tag ">
                                          {purchaseOrder?.city},
                                        </p>
                                        <p className="xetgo-font-tag ">
                                          {purchaseOrder?.pincode}.
                                        </p>
                                      </div>
                                      <p className="xetgo-font-tag">
                                        {purchaseOrder?.address_line}
                                      </p>
                                    </div>
                                    <div className="purchase-order-status-main-container flex-row align-items-center gap-2">
                                      <p
                                        style={{
                                          background:
                                            CLIENT_PO_PROPERTY_MAP[
                                              purchaseOrder.status
                                            ].backgroundColor,
                                          color:
                                            CLIENT_PO_PROPERTY_MAP[
                                              purchaseOrder.status
                                            ].color,
                                        }}
                                        className="flex-1 py-10 current-status xetgo-font-tag bolder"
                                      >
                                        {purchaseOrder?.status}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  onClick={(e) => e.stopPropagation()}
                                  className={`${"flex-column gap-24"} `}
                                >
                                  {" "}
                                  {openCommentSectionId !==
                                    purchaseOrder.id && (
                                    <div
                                      className="comment-icon flex-row align-items-center justify-content-center p-4"
                                      onClick={(e) => {
                                        openComment(purchaseOrder.id);
                                        setOpenCommentSectionId(
                                          purchaseOrder.id
                                        );
                                      }}
                                    >
                                      <img
                                        height={16}
                                        width={16}
                                        src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240117070437-chatbubbles.svg"
                                        alt="chat-icon"
                                      />
                                    </div>
                                  )}
                                  {openCommentSectionId ===
                                    purchaseOrder.id && (
                                    <div
                                      onClick={(e) => e.stopPropagation()}
                                      className="comment-floating-section"
                                    >
                                      <OutsideAlerter action={closeComment}>
                                        <div className="pr-comment-page">
                                          <CommentSection
                                            source="PURCHASE_REQUEST"
                                            showHeader={true}
                                            source_id={purchaseOrder.id}
                                            handleClose={closeComment}
                                          />
                                        </div>
                                      </OutsideAlerter>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="po-multi-boxes gap-12 flex-1 xetgo-font-tag">
                              <div
                                className="po-enquiry-id-box upper-big-boxes justify-content-center flex-column gap-12 px-12 py-14 justify-content-space-between cursor-pointer"
                                onClick={() =>
                                  window.open(purchaseOrder.po_file, "_blank")
                                }
                              >
                                <div className="inner-text-box flex-column gap-8">
                                  <p className="bold">Purchase Order</p>
                                  <div
                                    className="flex-row justify-content-space-between"
                                    style={{ alignItems: "flex-end" }}
                                  >
                                    <p className="box-title">
                                      {purchaseOrder.po_number}
                                    </p>
                                    <p className=" box-title">
                                      {formatDate(purchaseOrder.po_date)}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className=" upper-big-boxes justify-content-center flex-column gap-12 px-12 py-14 justify-content-space-between">
                                <div className="inner-text-box flex-column gap-8">
                                  <p className="bold sub-title">PO Value</p>
                                  <p className=" box-title">
                                    ₹{" "}
                                    {commaFormat(
                                      purchaseOrder.po_value.toString()
                                    )}
                                  </p>
                                </div>
                              </div>
                              <div className="upper-big-boxes justify-content-center flex-column gap-12 px-12 py-14 justify-content-space-between">
                                <div className="inner-text-box flex-column gap-8">
                                  <p className="bold sub-title">Vendor</p>
                                  <p className="box-title">
                                    {purchaseOrder?.vendor_name}
                                  </p>
                                </div>
                              </div>

                              <div className="flex-column gap-4">
                                <div className=" upper-big-boxes justify-content-center flex-column gap-12 px-12 py-14 ">
                                  <div className="inner-text-box flex-row gap-8 justify-content-space-between">
                                    <div className="address-title flex-column gap-4">
                                      <div className="flex-row gap-2">
                                        <p>{purchaseOrder?.city},</p>
                                        <p>{purchaseOrder?.pincode}.</p>
                                      </div>
                                      <p>{purchaseOrder?.address_line}</p>
                                    </div>
                                    <div className="purchase-order-status-main-container flex-row align-items-center gap-2">
                                      <p
                                        style={{
                                          background:
                                            CLIENT_PO_PROPERTY_MAP[
                                              purchaseOrder.status
                                            ].backgroundColor,
                                          color:
                                            CLIENT_PO_PROPERTY_MAP[
                                              purchaseOrder.status
                                            ].color,
                                        }}
                                        className="flex-1 py-10 current-status bolder"
                                      >
                                        {purchaseOrder?.status}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {(breakpoint === ScreenSizes.TABLET ||
                            breakpoint === ScreenSizes.LAPTOP ||
                            breakpoint === ScreenSizes.DESKTOP) && (
                            <div
                              onClick={(e) => e.stopPropagation()}
                              className="flex-column gap-24"
                            >
                              {openCommentSectionId !== purchaseOrder.id && (
                                <div
                                  className="comment-icon flex-row align-items-center justify-content-center p-4"
                                  onClick={(e) => {
                                    openComment(purchaseOrder.id);
                                    setOpenCommentSectionId(purchaseOrder.id);
                                  }}
                                >
                                  <img
                                    height={16}
                                    width={16}
                                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240117070437-chatbubbles.svg"
                                    alt="chat-icon"
                                  />
                                </div>
                              )}

                              {openCommentSectionId === purchaseOrder.id && (
                                <div
                                  onClick={(e) => e.stopPropagation()}
                                  className="comment-floating-section"
                                >
                                  <OutsideAlerter action={closeComment}>
                                    <div className="pr-comment-page">
                                      <CommentSection
                                        source="PURCHASE_REQUEST"
                                        showHeader={true}
                                        source_id={purchaseOrder.id}
                                        handleClose={closeComment}
                                      />
                                    </div>
                                  </OutsideAlerter>
                                </div>
                              )}

                              <img
                                onClick={() => handleCollapse(purchaseOrder.id)}
                                style={
                                  hiddenPos.includes(purchaseOrder.id)
                                    ? { rotate: "180deg" }
                                    : {}
                                }
                                className="cursor-pointer"
                                height={28}
                                width={28}
                                src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250618103555-download.svg"
                                alt="minimise-icon"
                              />
                            </div>
                          )}
                        </div>
                        {purchaseOrder.products.length > 0 &&
                          !hiddenPos.includes(purchaseOrder.id) && (
                            <div className="products-main-container">
                              <div className="products-header-row sku-products-grid xetgo-font-tag bold">
                                <p className="px-12 py-9 flex-row align-items-center border-right">
                                  SKU
                                </p>
                                <p className="px-12 border-right py-9 flex-row align-items-center">
                                  Price/Unit
                                </p>
                                <p className="px-12 py-9 flex-row border-right align-items-center">
                                  Qty
                                </p>
                                <p className="px-12 py-9 border-right flex-row align-items-center">
                                  Delivered
                                </p>
                                <p className="border-right px-12 py-9 flex-row align-items-center">
                                  Pending
                                </p>
                                <p className="px-12 py-9 flex-row align-items-center">
                                  Next Delivery
                                </p>
                              </div>
                              {purchaseOrder.products.map((sku, skuIndex) => (
                                <div
                                  key={skuIndex}
                                  className="sku-products-grid sku-product-row xetgo-font-tag"
                                >
                                  <p className="px-12 py-9 flex-row align-items-center border-right title flex-row align-items-center justify-content-space-between">
                                    <span>{sku.product_name}</span>{" "}
                                    <Tooltip title={` ${sku.description}`}>
                                      <img
                                        className="cursor-pointer"
                                        height={14}
                                        width={14}
                                        src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20241010065237-eye.svg"
                                        alt="eye-icon"
                                      />
                                    </Tooltip>
                                  </p>
                                  <p className="px-12 py-9 flex-row align-items-center border-right title">
                                    ₹ {sku.price}
                                  </p>
                                  <p className="flex-row gap-2 align-items-center px-12 py-9 flex-row align-items-center border-right title">
                                    <span> {sku.quantity}</span>{" "}
                                    <span className="sub-title">
                                      {" "}
                                      {sku.unit}
                                    </span>
                                  </p>
                                  <p className="flex-row gap-2 align-items-center px-12 py-9 flex-row align-items-center border-right title">
                                    <span>
                                      {" "}
                                      {sku.delivery_schedules.delivered}
                                    </span>{" "}
                                    <span className="sub-title">
                                      {" "}
                                      {sku.unit}
                                    </span>
                                  </p>
                                  <p className="flex-row gap-2 align-items-center px-12 py-9 flex-row align-items-center border-right title">
                                    <span>
                                      {" "}
                                      {sku.delivery_schedules.pending_quantity}
                                    </span>{" "}
                                    <span className="sub-title">
                                      {" "}
                                      {sku.unit}
                                    </span>
                                  </p>
                                  <div className="flex-row gap-2 align-items-center justify-content-space-between px-12 py-9 flex-row align-items-center border-right title">
                                    <p className="flex-row gap-2 align-items-center flex-row align-items-center title">
                                      <span>
                                        {" "}
                                        {sku.delivery_schedules.next_delivery
                                          ?.quantity || "-"}
                                      </span>{" "}
                                      <span className="sub-title">
                                        {" "}
                                        {sku.delivery_schedules.next_delivery
                                          ? sku.unit
                                          : "-"}
                                      </span>
                                    </p>
                                    <p>
                                      {" "}
                                      {
                                        sku.delivery_schedules.next_delivery
                                          ?.date
                                      }
                                    </p>{" "}
                                    <img
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setDeliveryShowInfoId(
                                          sku.procurement_request_product_id
                                        );
                                      }}
                                      className="cursor-pointer"
                                      height={14}
                                      width={14}
                                      src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250618140315-bi_info.svg"
                                      alt="info-icon"
                                    />
                                  </div>
                                  <div
                                    onClick={(e) => e.stopPropagation()}
                                    className=""
                                  >
                                    {breakpoint == ScreenSizes.MINI_TABLET ||
                                    breakpoint == ScreenSizes.MOBILE ? (
                                      <XetModal
                                        backdropClose={true}
                                        open={
                                          deliveryShowInfoId ===
                                          sku.procurement_request_product_id
                                        }
                                        handleClose={() =>
                                          setDeliveryShowInfoId(-1)
                                        }
                                      >
                                        <PurchaseOrderDeliveryDetailPopupTab
                                          procurementReuqestProductId={
                                            sku.procurement_request_product_id
                                          }
                                          handleClose={() =>
                                            setDeliveryShowInfoId(-1)
                                          }
                                          unit={sku.unit}
                                          skuName={sku.product_name}
                                        />
                                      </XetModal>
                                    ) : (
                                      <XetModal
                                        backdropClose={true}
                                        open={
                                          deliveryShowInfoId ===
                                          sku.procurement_request_product_id
                                        }
                                        handleClose={() =>
                                          setDeliveryShowInfoId(-1)
                                        }
                                      >
                                        <PurchaseOrderDeliveryDetailPopup
                                          procurementReuqestProductId={
                                            sku.procurement_request_product_id
                                          }
                                          handleClose={() =>
                                            setDeliveryShowInfoId(-1)
                                          }
                                          unit={sku.unit}
                                        />
                                      </XetModal>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}

                        {(breakpoint === ScreenSizes.MINI_TABLET ||
                          breakpoint === ScreenSizes.MOBILE ||
                          breakpoint === ScreenSizes.TABLET) &&
                          purchaseOrder.products.length > 0 &&
                          !hiddenPos.includes(purchaseOrder.id) && (
                            <div className="all-purchase-order-products-container flex-column gap-12">
                              {/* {purchaseOrder.products.map((sku, skuIndex) => ( */}
                              {purchaseOrder.products.map((product, index) => (
                                <div
                                  key={index}
                                  className="product-delivery-detail-container p-12 flex-column gap-16 xetgo-font-tag"
                                >
                                  {product.product_name}
                                  <div className="flex-row justify-content-space-between">
                                    <div className="flex-row gap-12 align-items-center">
                                      <p className=" bold">SKU:</p>
                                      <p
                                        style={{ color: "#4A4A4A9E" }}
                                        className="bold"
                                      >
                                        {product.product_name || "-"}
                                      </p>
                                      <Tooltip
                                        title={` ${product.description}`}
                                      >
                                        <img
                                          className="cursor-pointer"
                                          height={14}
                                          width={14}
                                          src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250919060855-bi_info.svg"
                                          alt="alt-info-icon"
                                        />
                                      </Tooltip>
                                    </div>
                                    <div className="flex-row gap-12 align-items-center">
                                      <p
                                        style={{ color: "#4A4A4A9E" }}
                                        className=" bold"
                                      >
                                        ₹{" "}
                                        {commaFormat(
                                          product.quantity.toString()
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="flex-row justify-content-space-between">
                                    <div className="flex-row gap-12 align-items-center">
                                      <p className=" bold">Qty:</p>
                                      <p
                                        style={{ color: "#333333" }}
                                        className="bold"
                                      >
                                        {product.delivery_schedules.delivered +
                                          product.delivery_schedules
                                            .pending_quantity || "-"}{" "}
                                        <span style={{ color: "#4A4A4A9E" }}>
                                          {product.unit}
                                        </span>
                                      </p>
                                    </div>
                                    <div className="flex-row gap-12 align-items-center">
                                      <p className=" bold"> Delivered:</p>
                                      <p
                                        style={{ color: "#333333" }}
                                        className="bold"
                                      >
                                        {product.delivery_schedules.delivered}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="flex-row justify-content-space-between">
                                    <div className="flex-row gap-12 align-items-center">
                                      <p className="bold">Pending:</p>
                                      <p
                                        style={{ color: "#333333" }}
                                        className=" bold"
                                      >
                                        {product.delivery_schedules
                                          .pending_quantity || "-"}{" "}
                                        <span style={{ color: "#4A4A4A9E" }}>
                                          {product.unit}
                                        </span>
                                      </p>
                                    </div>
                                    <div className="flex-row gap-12 align-items-center">
                                      <p className="bold"> Next:</p>
                                      <p
                                        style={{ color: "#333333" }}
                                        className=" bold"
                                      >
                                        {product.delivery_schedules
                                          .next_delivery?.quantity && (
                                          <>
                                            {" "}
                                            <span>
                                              {product.delivery_schedules
                                                ?.next_delivery?.quantity ||
                                                "-"}
                                            </span>{" "}
                                            <span
                                              style={{ color: "#4A4A4A9E" }}
                                            >
                                              {product.unit}
                                            </span>{" "}
                                          </>
                                        )}
                                        <span>
                                          {product.delivery_schedules
                                            ?.next_delivery?.date || "-"}
                                        </span>
                                      </p>
                                      <img
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setDeliveryShowInfoId(
                                            product.procurement_request_product_id
                                          );
                                        }}
                                        className="cursor-pointer"
                                        height={14}
                                        width={14}
                                        src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250618140315-bi_info.svg"
                                        alt="info-icon"
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                      </div>
                    );
                  }
                )}
            </div>
          </div>
        ) : (
          <div className="po-status-list-container flex-column full-height gap-12 align-items-center justify-content-center ">
            <img
              height={58}
              width={58}
              src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240409110035-Layers.svg"
              alt="empty-state"
            />
            <p className="xetgo-font-body bolder">No Purchase Order Found</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientPurchaseOrderStatus;
